import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
          light: {
            primary: '#6ed88b',
            secondary: '#776ff3',
            accent: '#8c9eff',
            error: '#b71c1c',
          },
        },
    }
});
